import { useDataProvider } from "react-admin";
import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import CustomLabeled from "../../../components/layout/CustomLabeled";

interface ISchoolTargetField {
  schoolId: number;
}

const SchoolTargetField = ({ schoolId }: ISchoolTargetField) => {
  const provider = useDataProvider();
  const [school, setSchool] = useState<ISchool>();

  useEffect(() => {
    if (schoolId) {
      provider
        .getOne("schools", {
          id: schoolId,
        })
        .then(({ data }) => {
          setSchool(data as ISchool);
        });
    }
  }, [schoolId]);

  return (
    <CustomLabeled name="School Name">
      {school ? (
        <Typography variant="body2">{school.name}</Typography>
      ) : (
        <Typography variant="body2">-</Typography>
      )}
    </CustomLabeled>
  );
};

export default SchoolTargetField;
